import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ArticleCard, DynamicMediaItem } from '../../../../components';
import { CustomNodeArticle } from '../../custom';

import './style.scss';

interface ArticleTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<CustomNodeArticle>;
}

const ArticleTeaser: React.FC<ArticleTeaserProps> = ({ entity, ...props }) => {
  const article = entity.toJS();
  const title = article.title[0].value;
  const summary = article.body[0]?.summary;
  const media = article.field_media_item[0];

  return (
    <ArticleCard
      {...props}
      // TODO: Fetch the location through the contact_person.
      subtitle={summary}
      link={article.paths.nl}
      readTime={Number(article.node_read_time[0].value)}
      publicationDate={new Date(article.created[0].value)}
      title={title}
      image={media && <DynamicMediaItem media={media} imageAspectRatio="4_3" />}
    />
  );
};

export default ArticleTeaser;
